/**
 * تبدیل لینک اشتراک آپارات (/v/HASH یا URL کامل صفحه) به آدرس embed برای iframe.
 * اگر قبلاً آدرس embed باشد همان را برمی‌گرداند.
 */
export function aparatShareToEmbedUrl(input: string | null | undefined): string | null {
  const raw = (input || '').trim();
  if (!raw) return null;
  if (/aparat\.com\/video\/video\/embed\//i.test(raw)) {
    try {
      return new URL(raw).toString();
    } catch {
      return raw;
    }
  }
  try {
    const href = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
    const url = new URL(href);
    const path = url.pathname.replace(/\/+$/, '');
    const vMatch = path.match(/\/v\/([^/\s?]+)$/i);
    if (vMatch?.[1]) {
      const hash = vMatch[1];
      return `https://www.aparat.com/video/video/embed/videohash/${encodeURIComponent(hash)}/vt/frame`;
    }
    const hashMatch = path.match(/videohash\/([^/\s?]+)/i);
    if (hashMatch?.[1]) {
      return `https://www.aparat.com/video/video/embed/videohash/${encodeURIComponent(hashMatch[1])}/vt/frame`;
    }
  } catch {
    /* ignore */
  }
  return null;
}
